import { ref, push, serverTimestamp } from 'firebase/database'
import { db } from './FirebaseService'
import { getUid } from './AuthService'

const VENDOR_ID = process.env.VUE_APP_VENDOR_ID;

/**
 * Process URL update from parent window and push to Firebase
 * @param {string} url - The new URL
 */
async function processUrlUpdate(url) {
  try {
    const uid = getUid()
    
    if (!uid) {
      console.warn('No authenticated user found, skipping URL tracking')
      return
    }
    
    // Push URL data to Firebase
    const urlData = {
      type: 'visit',
      url: url,
      timestamp: serverTimestamp()
    }
    
    const userJourneyRef = ref(db, `user_journey/${VENDOR_ID}/${uid}/`)
    await push(userJourneyRef, urlData)
    
    console.log('URL tracked:', url)
  } catch (error) {
    console.error('Error tracking URL:', error)
  }
}

/**
 * Initialize the URL tracker listener
 * This should be called once when the app starts
 */
export function initializeUrlTracker() {
  window.addEventListener('message', (event) => {
    // Validate message origin if needed
    // You might want to add origin validation here for security
    
    if (event.data && event.data.type === 'url_update') {
      processUrlUpdate(event.data.url)
    }
  })
  
  // Notify parent that iframe is ready to receive URLs
  window.parent.postMessage({
    type: 'trackUrl'
  }, '*')
  
  console.log('URL tracker initialized and parent notified')
}
